var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalclasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Total_Classes"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 26
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_Classes",
    "data-name": "Total Classes",
    clipPath: "url(#clip-Total_Classes)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M7.689,16H2.5A2.5,2.5,0,0,1,0,13.5v-9A2.5,2.5,0,0,1,2.5,2H3V.5a.5.5,0,1,1,1,0V2h8V.5a.5.5,0,1,1,1,0V2h.5A2.5,2.5,0,0,1,16,4.5V9.044a5.968,5.968,0,0,0-1-.355V6H1v7.5A1.5,1.5,0,0,0,2.5,15H7.52a6,6,0,0,0,.168,1ZM13,3V5h2V4.5A1.5,1.5,0,0,0,13.5,3ZM4,3V5h8V3ZM2.5,3A1.5,1.5,0,0,0,1,4.5V5H3V3Zm4,11a.5.5,0,1,1,.5-.5A.5.5,0,0,1,6.5,14Zm-3,0a.5.5,0,1,1,.5-.5A.5.5,0,0,1,3.5,14Zm3-3a.5.5,0,1,1,.5-.5A.5.5,0,0,1,6.5,11Zm-3,0a.5.5,0,1,1,.5-.5A.5.5,0,0,1,3.5,11ZM9,10.53v0c0-.009,0-.018,0-.027a.5.5,0,0,1,.5-.5H9.53A6.071,6.071,0,0,0,9,10.528ZM12.5,8a.5.5,0,1,1,.5-.5A.5.5,0,0,1,12.5,8Zm-3,0a.5.5,0,1,1,.5-.5A.5.5,0,0,1,9.5,8Zm-3,0A.5.5,0,1,1,7,7.5.5.5,0,0,1,6.5,8Z",
    transform: "translate(3 3)",
    fill: "#410a8c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(10.265 8.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4219",
    "data-name": "Path 4219",
    d: "M8.35,25.069v-.856A1.713,1.713,0,0,0,6.638,22.5H3.213A1.713,1.713,0,0,0,1.5,24.213v.856",
    transform: "translate(0 -12.862)",
    fill: "none",
    stroke: "#410a8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4220",
    "data-name": "Path 4220",
    d: "M10.925,6.213A1.713,1.713,0,1,1,9.213,4.5,1.713,1.713,0,0,1,10.925,6.213Z",
    transform: "translate(-4.287 0)",
    fill: "none",
    stroke: "#410a8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4221",
    "data-name": "Path 4221",
    d: "M31.284,25.208v-.856A1.713,1.713,0,0,0,30,22.7",
    transform: "translate(-20.365 -13.002)",
    fill: "none",
    stroke: "#410a8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4222",
    "data-name": "Path 4222",
    d: "M24,4.695a1.713,1.713,0,0,1,0,3.318",
    transform: "translate(-16.078 -0.139)",
    fill: "none",
    stroke: "#410a8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalclasses);
export default __webpack_public_path__ + "static/media/totalclasses.333edf6a38480221dbad146de56ec70b.svg";
export { ForwardRef as ReactComponent };